import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Onboarding/FormStyles.module.scss'
import classnames from 'classnames'
import {
  NumberFormField,
  SelectDropdownFormField
} from 'belle-js'
import {
  currencyValidation
} from 'utils/fieldValidations'
import {
  simpleCompYears
} from 'utils/financialAccountAdditionalDetailsOptions'

const LimitedEligibilty = (props) => {
  const conditionalTextMargin = classnames(
    styles.textLight,
    styles.conditionalTextMargin
  )

  const inputSeparatorsText = classnames(
    styles.inputSeparatorMargin,
    styles.textLight
  )

  const { data } = props

  return (
    <div className={styles.indentedConditionalWrapper}>
      <div className={styles.text}>
        Eligibility is limited to each Employee who satisfies
        the requirements in both (a) and (b) below.
      </div>
      <div className={styles.textLight}>
        A.) Prior Year Compensation. An Employee who has
        received at least $5,000, or
      </div>
      <div className={styles.inputWrapper}>
        <NumberFormField
          format="currency"
          allowDecimal={true}
          name="simplePriorYearCompAmount"
          className={styles.FormFieldInSection}
          placeholder="0"
          validations={currencyValidation.rules}
          validationErrors={currencyValidation.messages}
          value={data.simplePriorYearCompAmount || ''}
          required={false}
          testId="simplePriorYearCompAmount" />
      </div>
      <div className={inputSeparatorsText}>
        if lesser, in Compensation during any 2, or
      </div>
      <div className={styles.conditionalDropdownMargin}>
        <div className={styles.inputWrapper}>
          <SelectDropdownFormField
            name="simplePriorYearCompYears"
            className="dropdown"
            options={simpleCompYears}
            value={data.simplePriorYearCompYears || ''}
            testId="simplePriorYearCompYears" />
        </div>
      </div>
      <div className={inputSeparatorsText}>
        if fewer, preceding Years (need not be consecutive); and
      </div>
      <div className={conditionalTextMargin}>
        B.) Current Year Compensation. An Employee who is
        reasonably expected to receive at least $5,000, or
      </div>
      <div className={styles.inputWrapper}>
        <NumberFormField
          format="currency"
          allowDecimal={true}
          name="simpleCurrentYearCompAmount"
          className={styles.FormFieldInSection}
          placeholder="0"
          validations={currencyValidation.rules}
          validationErrors={currencyValidation.messages}
          value={data.simpleCurrentYearCompAmount || ''}
          required={false}
          testId="simpleCurrentYearCompAmount" />
      </div>
      <div className={inputSeparatorsText}>
        if lesser, in Compensation during the current Year.
      </div>
    </div>
  )
}

LimitedEligibilty.propTypes = {
  data: PropTypes.object.isRequired
}

export default LimitedEligibilty



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/LimitedEligibilty/LimitedEligibilty.jsx